export function Sponsor() {
  return (
    <div className="page">
      <header className="page__header">
        <p className="eyebrow">Sponsor</p>
        <h1>Help fund the next chapter of DreamGraph.</h1>
        <p className="lede">
          DreamGraph is built and maintained by a solo developer on aging hardware. If the daemon
          saves your team time — onboarding an engineer, debugging a multi-repo system, or keeping
          a SaaS data model honest — please consider sponsoring.
        </p>
      </header>

      <section className="sponsor-goal">
        <h2>Current goal: $300/mo</h2>
        <p>
          Funds a 64&nbsp;GB DDR5 / NVMe dev machine that can run the upcoming multi-engine datastore
          test matrix (Postgres + MySQL + MSSQL + Mongo + Redis containers in parallel) without
          thermal-throttling.
        </p>
        <a className="btn btn--primary" href="https://github.com/sponsors/mmethodz" target="_blank" rel="noreferrer">
          Sponsor on GitHub →
        </a>
      </section>

      <section>
        <h2>Where the money goes</h2>
        <ul className="sponsor-list">
          <li><strong>Hardware that doesn’t catch fire</strong> when running 20 DreamGraph instances next to a Postgres container and a WSL kernel.</li>
          <li><strong>CI infrastructure</strong> for the multi-engine datastore tests on the v8.3 → v8.9 roadmap.</li>
          <li><strong>More frequent releases</strong> — fewer hours on contract work, more hours on the daemon, the cognitive engine, the Architect, and documentation.</li>
        </ul>
      </section>

      <section>
        <h2>Tier ladder</h2>
        <table className="tier-table">
          <thead>
            <tr><th>Tier</th><th>What you get</th></tr>
          </thead>
          <tbody>
            <tr><td>$5/mo</td><td>Sponsor badge + name in <code>SPONSORS.md</code></td></tr>
            <tr><td>$10/mo</td><td>Release-notes thanks</td></tr>
            <tr><td>$25/mo</td><td>Logo in the README</td></tr>
            <tr><td>$100/mo</td><td>Priority issue triage</td></tr>
            <tr><td>$500/mo</td><td>Logo + monthly office hour</td></tr>
            <tr><td>$1,000/mo</td><td>Embedded support in your team chat</td></tr>
          </tbody>
        </table>
        <p>
          One-time tiers cover release-notes mentions, pair programming, consulting, sponsored
          bugfixes, and contract work.
        </p>
      </section>
    </div>
  );
}
